var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('border-active-block',{staticClass:"angle-hover-card-container",class:{'active': _vm.active},attrs:{"active":_vm.active}},[(_vm.withAngle)?_c('div',{staticClass:"angle"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }